export default __webpack_public_path__ + "static/media/logo.d2262e3f.png";